import { useQuery } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export interface AiActionDto {
  id: string;
  slug: string;
  name: string;
  description?: string | null;
  icon?: string | null;
  category?: string | null;
  provider?: string | null;
  parametersSchema: unknown;
  source: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  traceId?: string | null;
}

export function useAIActions() {
  const { getToken } = useAuth();
  return useQuery<AiActionDto[]>({
    queryKey: ['ai-actions'],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const response = await client
        .get('api/v2/ai-actions')
        .json<ApiResponse<AiActionDto[]>>();
      return response.data ?? [];
    },
  });
}
